/**
 * @file Accordions List
 */

import { gsap } from 'gsap';

/**
 * Accordions List component
 */
const vAccordionsList = () => {
	const accordionsList = document.querySelector( '.v-accordions-list' );
	if ( ! accordionsList ) {
		return;
	}

	const triggers  = accordionsList.querySelectorAll( '.v-accordions-list__trigger' );
	let isAnimating = false;
	const tl        = gsap.timeline( {
		defaults: { ease: 'sine.out', duration: .3 },
		onStart:  () => {
			isAnimating = true;
		},
		onComplete: () => {
			isAnimating = false;
		},
	} );

	[ ...triggers ].forEach( ( trigger ) => {
		trigger.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			if ( isAnimating ) {
				return;
			}

			const item   = trigger.closest( '.v-accordions-list__item' );
			const answer = item.querySelector( '.v-accordions-list__answer' );
			const isOpen = item.classList.contains( 'open' );

			if ( isOpen ) {
				tl
					.to( answer, { opacity: 0 } )
					.to( answer, {
						height:     0,
						onComplete: () => {
							item.classList.remove( 'open' );
							trigger.setAttribute( 'aria-expanded', 'false' );
							answer.removeAttribute( 'style' );
						},
					}, '>' );
			} else {
				const answerInner    = answer.querySelector( '.v-accordions-list__answer-inner' );
				answer.style.display = 'block';

				tl
					.to( answer, {
						height: answerInner.getBoundingClientRect().height,
					} )
					.fromTo( answer, { opacity: 0 }, {
						opacity:    1,
						onComplete: () => {
							trigger.setAttribute( 'aria-expanded', 'true' );
							item.classList.add( 'open' );
							answer.removeAttribute( 'style' );
						},
					}, '>' );
			}
		} );
	} );
};

export default vAccordionsList;
